export default "__VITE_ASSET__21fb8d00__"